'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _findIndex3 = require('lodash/findIndex');

var _findIndex4 = _interopRequireDefault(_findIndex3);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var moveTreeRows = function moveTreeRows() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      operation = _ref.operation,
      _ref$retain = _ref.retain,
      retain = _ref$retain === undefined ? [] : _ref$retain,
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField;

  if (!operation) {
    throw new Error('tree.moveRows - Missing operation!');
  }

  return function (rows) {
    var movedRows = operation(rows);
    var cancelMoving = false;

    if (movedRows) {
      // Walk through the old row definition, patch parent relations and fields
      // of the new one
      movedRows = rows.map(function (row, i) {
        var _extends3;

        if (typeof row[parentField] === 'undefined' || row[parentField] === null) {
          var _extends2;

          return _extends({}, (0, _omit3.default)(movedRows[i], retain), (0, _pick3.default)(row, retain), (_extends2 = {}, _defineProperty(_extends2, idField, movedRows[i][idField]), _defineProperty(_extends2, parentField, undefined), _extends2));
        }

        // Find the index of the old parent
        var index = (0, _findIndex4.default)(rows, _defineProperty({}, idField, row[parentField]));

        if (index < 0) {
          console.warn( // eslint-disable-line no-console
          'tree.moveRows - Failed to find the old parent', rows, row, idField, parentField);

          cancelMoving = true;

          return null;
        }

        // Figure out the new id based on that index
        var id = movedRows[index][idField];

        return _extends({}, (0, _omit3.default)(movedRows[i], retain), (0, _pick3.default)(row, retain), (_extends3 = {}, _defineProperty(_extends3, idField, movedRows[i][idField]), _defineProperty(_extends3, parentField, id), _extends3));
      });
    }

    if (cancelMoving) {
      return rows;
    }

    return movedRows;
  };
};

exports.default = moveTreeRows;